export default __webpack_public_path__ + "static/media/tickMark_withBg.5fbc6662.svg";